import Footer from "../../components/Footer";
import UNI_1 from "../../assets/img//uni_1.png";
import UNI_2 from "../../assets/img//uni_2.png";
import PG_2 from "../../assets/img/pg_2.png";
import PG_3 from "../../assets/img/pg_3.png";
import LanImg_2 from "../../assets/img/ourStory.png";
import "../style.css";
import PageWiseLearnMore from "./PageWiseLearnMore";
import LearnMoreSection from "./LearnMoreSection";
import Group from "./Group";
import { useParams } from "react-router-dom";
export default function UniversityPreparation() {
  const { id } = useParams();


  const learnMoreDataCourseFinder = {
    topHeaderSection: {
      header: "Oxbridge Application Service",
      desc: "The Oxbridge Application Service specialises in helping international students find a place at the Global top universities.",
      img: UNI_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header: "Expert guidance for applying to the Global top universities",
      desc: "Gaining admission to prestigious institutions like Oxford and Cambridge requires exceptional academic credentials, a flawless application, and an in-depth understanding of their rigorous admissions processes. With limited places available across all courses, competition is intense. Global StudyIn’s Oxbridge Application Service gives you a decisive advantage. Our consultants have successfully guided hundreds of international students through this challenging process and, whether you’re applying for undergraduate or postgraduate study, our specialists will ensure your application stands out. Benefit from proven strategies that have helped students secure places at the world’s best universities.",
    },
    thirdSection: {
      rightSection: {
        img: UNI_2,
      },
      leftSection: {
        header: "What is included?",
        desc: "The Oxbridge Application Service covers every aspect of your application to ensure you have the best chance of gaining admission into one of the Global top universities.",
      },
      leftColumnContent: [
        {
          title: "University selection guidance",
          description:
            "Our expert counsellors will evaluate your study goals and provide personalised guidance on Global university and course options",
        },
        {
          title: "Eligibility assessment",
          description:
            "We will review your transcripts, qualifications, and academic background to confirm your eligibility to your preferred university and course",
        },
        {
          title: "Personal statement advice",
          description:
            "Get guidance on how to structure and write a personal statement that matches the expectations of top universities",
        },
        {
          title: "Application management and tracking",
          description:
            "Receive assistance completing and reviewing your university application forms, followed by full tracking to keep you informed of their progress",
        },
        {
          title: "Admissions test preparation",
          description:
            "We will ensure you meet deadlines and provide guidance on required admissions tests such as the GMAT",
        },
        {
          title: "Interview preparation",
          description:
            "Participate in a non-subject-specific interview with an Oxbridge alumnus and receive a feedback report on what and where to improve",
        },
        {
          title: "Documentation support",
          description:
            "Understand what academic transcripts, reference letters, and other documents you need to submit with your application",
        },
        {
          title: "Reading list recommendations",
          description:
            "Get access to a tailored reading list to expand your knowledge and help you prepare for the interview",
        },
      ],
      rightColumnContent: [

      ],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
  };

  const learnMoreDataServices = {
    topHeaderSection: {
      header: "Oxbridge Application Service",
      desc: "The Oxbridge Application Service specialises in helping international students find a place at the Global top universities.",
      img: UNI_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header: "Expert guidance for applying to the Global top universities",
      desc: "Gaining admission to prestigious institutions like Oxford and Cambridge requires exceptional academic credentials, a flawless application, and an in-depth understanding of their rigorous admissions processes. With limited places available across all courses, competition is intense. Global StudyIn’s Oxbridge Application Service gives you a decisive advantage. Our consultants have successfully guided hundreds of international students through this challenging process and, whether you’re applying for undergraduate or postgraduate study, our specialists will ensure your application stands out. Benefit from proven strategies that have helped students secure places at the world’s best universities.",
    },
    thirdSection: {
      rightSection: {
        img: UNI_2,
      },
      leftSection: {
        header: "What is included?",
        desc: "The Oxbridge Application Service covers every aspect of your application to ensure you have the best chance of gaining admission into one of the Global top universities.",
      },
      leftColumnContent: [
        {
          title: "University selection guidance",
          description:
            "Our expert counsellors will evaluate your study goals and provide personalised guidance on Global university and course options",
        },
        {
          title: "Eligibility assessment",
          description:
            "We will review your transcripts, qualifications, and academic background to confirm your eligibility to your preferred university and course",
        },
        {
          title: "Personal statement advice",
          description:
            "Get guidance on how to structure and write a personal statement that matches the expectations of top universities",
        },
        {
          title: "Application management and tracking",
          description:
            "Receive assistance completing and reviewing your university application forms, followed by full tracking to keep you informed of their progress",
        },
        {
          title: "Admissions test preparation",
          description:
            "We will ensure you meet deadlines and provide guidance on required admissions tests such as the GMAT",
        },
        {
          title: "Interview preparation",
          description:
            "Participate in a non-subject-specific interview with an Oxbridge alumnus and receive a feedback report on what and where to improve",
        },
        {
          title: "Documentation support",
          description:
            "Understand what academic transcripts, reference letters, and other documents you need to submit with your application",
        },
        {
          title: "Reading list recommendations",
          description:
            "Get access to a tailored reading list to expand your knowledge and help you prepare for the interview",
        },
      ],
      rightColumnContent: [

      ],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
    enablePaymentRedirection: true
  };
  const data = id == 1 ? learnMoreDataCourseFinder : learnMoreDataServices;

  return (
    <div className="personalised-guidance university-preparation">
      <PageWiseLearnMore activePageId={id} learnMoreData={data} />
      <Group />
      <LearnMoreSection learnMoreData={data} />

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
